import { getCurrentUser } from "../auth/getCurrentUser";
import { getComputerData, getUserData } from "./getUserData";

export const getCurrentUserInfo = async () => {
  const currentUser = getCurrentUser();
  const publicComputers = await getComputerData(currentUser.id);

  if (!currentUser) return null;
  return await getUserData(currentUser.id);
};
